import { api } from "@/api/axios.ts";
import { ApiEmployeeTimeOffCategoryPayload } from "@/types/employees/employee.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import {
  ApiEmployeeTimeOffCategory,
  ApiEmployeeTimeOffHistoryFilter,
  ApiEmployeeTimeOffRequestsFilter,
  ApiTimeOffCalendar,
  ApiTimeOffHistory,
  ApiTimeOffLogFull,
} from "@/types/time-off/time-off.types.ts";

export const apiEmployeeTimeOff = {
  categories: async function (employeeId: number, payload: ApiEmployeeTimeOffCategoryPayload) {
    return api.post<ApiEmployeeTimeOffCategory[]>(
      `/api/v1/employees/${employeeId}/time-off`,
      payload
    );
  },
  requests: async function (
    employeeId: number,
    filter: ApiEmployeeTimeOffRequestsFilter,
    signal?: AbortSignal
  ) {
    return api.post<ApiPagedData<ApiTimeOffLogFull>>(
      `/api/v1/employees/${employeeId}/time-off/search`,
      filter,
      signal
    );
  },
  history: async function (
    employeeId: number,
    filter: ApiEmployeeTimeOffHistoryFilter,
    signal?: AbortSignal
  ) {
    return api.post<ApiTimeOffHistory>(
      `/api/v1/employees/${employeeId}/time-off/history`,
      filter,
      signal
    );
  },
  calendar: async function (employeeId: number, year: number, signal?: AbortSignal) {
    return api.post<ApiTimeOffCalendar>(
      `/api/v1/employees/${employeeId}/time-off/calendar`,
      { year },
      signal
    );
  },
};
